import React from 'react';
import { Icon } from '@iconify/react';
import { useReveal } from '../hooks/useReveal';

const education = [{
	degree: 'BSc Mathematics',
	minor: 'Professional Minor in Computer Science',
	school: 'University of Buea',
	location: 'Cameroon',
	from: 'Oct 2017', to: 'Aug 2020', gpa: '3.14',
	highlights: [
		'Strong foundations in calculus, algebra, statistics, and discrete mathematics.',
		'Practical training in algorithms, data structures, and programming.',
	],
}];

const certifications = [
	{ name: 'ALX-T Full Stack Developer', issuer: 'Udacity / ALX', year: '2022', icon: 'mdi:certificate-outline', color: 'text-violet-400' },
	{ name: 'Mobile Web Specialist', issuer: 'Google Africa Developer Program', year: '2021', icon: 'mdi:google', color: 'text-blue-400' },
	{ name: 'Python for Everybody', issuer: 'Coursera', year: '2021', icon: 'mdi:language-python', color: 'text-cyan-400' },
	{ name: 'Support & Mentorship Award', issuer: 'Iknite Studio', year: '2025', icon: 'mdi:trophy-outline', color: 'text-amber-400' },
];

function Education() {
	const ref1 = useReveal();
	const ref2 = useReveal();
	return (
		<section className="max-w-6xl mx-auto px-6">
			<div className="grid md:grid-cols-2 gap-6">
				{/* Education */}
				<div ref={ref1} className="reveal">
					{education.map((edu, i) => (
						<div key={i} className="section-card h-full">
							<div className="flex items-center gap-3 mb-5">
								<div className="w-10 h-10 rounded-xl bg-accent/15 border border-accent/25 flex items-center justify-center flex-shrink-0">
									<Icon icon="mdi:school-outline" className="text-accent text-xl" />
								</div>
								<div>
									<p className="text-xs text-slate-500 font-semibold uppercase tracking-wide">Education</p>
									<h3 className="font-display font-semibold text-white">{edu.degree}</h3>
								</div>
							</div>
							<p className="text-accent text-sm font-medium mb-1">{edu.minor}</p>
							<p className="text-slate-400 text-sm">{edu.school} · {edu.location}</p>
							<p className="text-slate-600 text-xs mt-0.5 mb-4">{edu.from} – {edu.to} · GPA {edu.gpa}</p>
							<ul className="space-y-2">
								{edu.highlights.map((h, j) => (
									<li key={j} className="flex gap-2 text-sm text-slate-400">
										<span className="text-accent mt-0.5 flex-shrink-0 text-xs">▸</span>{h}
									</li>
								))}
							</ul>
						</div>
					))}
				</div>

				{/* Certifications */}
				<div ref={ref2} className="reveal reveal-delay-2 flex flex-col gap-3">
					{certifications.map((cert, i) => (
						<div key={i} className="section-card flex items-center gap-4 py-4 !p-4">
							<div className="w-10 h-10 rounded-xl bg-slate-800 border border-slate-700 flex items-center justify-center flex-shrink-0">
								<Icon icon={cert.icon} className={`${cert.color} text-xl`} />
							</div>
							<div className="flex-1 min-w-0">
								<p className="font-semibold text-white text-sm">{cert.name}</p>
								<p className="text-xs text-slate-500 mt-0.5">{cert.issuer}</p>
							</div>
							<span className="text-xs text-slate-600 font-medium flex-shrink-0">{cert.year}</span>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default Education;
